'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _createSpring = require('./steppers/createSpring');

var _createSpring2 = _interopRequireDefault(_createSpring);

var _createTimed = require('./steppers/createTimed');

var _createTimed2 = _interopRequireDefault(_createTimed);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function interp(from, to, t) {
  return from + (to - from) * t;
}

var STEPS_PER_SEC = 60;
var SEC_PER_STEP = 1 / STEPS_PER_SEC;

var Animator = function () {
  function Animator(layer, key, config) {
    var _this = this;

    _classCallCheck(this, Animator);

    this._tick = function () {
      var now = Date.now();
      var shouldStop = false;
      var stepsNeeded = Math.floor((now - _this._startTime) / 1000 / SEC_PER_STEP) - _this._stepsCompleted;

      for (var i = 0; i < stepsNeeded && !shouldStop; i++) {
        var _stepper = _this._stepper(_this._x, _this._v, SEC_PER_STEP, now - _this._startTime),
            _stepper2 = _slicedToArray(_stepper, 3),
            nextX = _stepper2[0],
            nextV = _stepper2[1],
            stepShouldStop = _stepper2[2];

        _this._x = nextX;
        _this._v = nextV;
        shouldStop = stepShouldStop;
      }
      _this._stepsCompleted += stepsNeeded;
      _this._value = interp(_this._from, _this._to, _this._x);
      _this._updater(_this._value);
      if (shouldStop) {
        _this._onEnd && _this._onEnd();
      } else {
        _this._raf = window.requestAnimationFrame(_this._tick);
      }
    };

    this._layer = layer;
    this._key = key;
    if (config.type === 'timed') {
      this._stepper = (0, _createTimed2.default)(config.duration);
    }
    if (config.type === 'spring') {
      this._stepper = (0, _createSpring2.default)(1, config.spring, config.friction);
    }
  }

  _createClass(Animator, [{
    key: 'start',
    value: function start(from, to, updater, onEnd) {
      this._startTime = Date.now();
      this._stepsCompleted = 0;
      this._x = 0;
      this._v = 0;
      this._value = from;
      this._from = from;
      this._to = to;
      this._updater = updater;
      this._tick();
      this._onEnd = onEnd;
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this._value;
    }
  }, {
    key: 'stop',
    value: function stop() {
      window.cancelAnimationFrame(this._raf);
    }
  }]);

  return Animator;
}();

exports.default = Animator;


//////////////////
// WEBPACK FOOTER
// ./~/buttery/lib/Animator.js
// module id = 165
// module chunks = 0